import axios, { isAxiosError } from "axios"

/**
 * Adds an email as a Viral Loops participant
 * @param {string} email the email address to register
 * @param {string} [referrerCode] the unique referral id of the referrer
 * @returns {{action: String, data?: {referralCode: String, isNew: boolean, shareUrl: String}, error?: String, code?: String}}
 */
export async function vlRegister(email: string, referrerCode?: string | null) {
  try {
    const data = {
      email,
      referrerCode,
    }

    const res = await axios.post(`/api/vl/register`, data)

    return {
      action: `VL_REGISTER_PARTICIPANT`,
      data: res.data,
    }
  } catch (error) {
    console.error({ error })
    return {
      action: `VL_REGISTER_PARTICIPANT`,
      error: error.response?.data.error.message,
      code: error.response?.data.error.code,
    }
  }
}

/**
 * Adds an email as a Viral Loops participant
 * @param {String} email the email address to register
 * @param {String} [referralCode] the unique referral id of the referrer
 * @returns {Object}
 */
export async function vlGetParticipantData(email, referralCode) {
  try {
    const data = {
      email,
      referralCode,
    }

    const res = await axios.post(`/api/vl/participantData`, data)

    return {
      action: `VL_GET_PARTICIPANT_DATA`,
      data: res.data,
    }
  } catch (error) {
    console.error(error)
    return {
      action: `VL_GET_PARTICIPANT_DATA`,
      error: error.response.data.error.message,
      code: error.response.data.error.code,
    }
  }
}

/**
 * Gets the campaign widget details
 * @returns {Object}
 */
export async function vlGetMilestoneData() {
  try {
    const res = await axios.get(`/api/vl/campaignData`)

    const cleanMilestones = res.data.widgets.milestoneWidget.milestones.map(
      m => {
        const sourceUrl = m.img.imgUrl
        const optimizedUrl = sourceUrl
          .replace(/\/upload\//, "/upload/h_400/")
          .replace(/.jpg$/, ".webp")
        return {
          description: m.description.text,
          imgUrl: optimizedUrl,
          referralsNeeded: m.referralsNeeded,
        }
      },
    )

    return {
      action: `VL_GET_MILESTONE_DATA`,
      data: cleanMilestones,
    }
  } catch (error) {
    console.error({ error })
    return {
      action: `VL_GET_MILESTONE_DATA`,
      error: error.response.data.error.message,
      code: error.response.data.error.code,
    }
  }
}
